import { render, staticRenderFns } from "./EditHotel.vue?vue&type=template&id=0847d90f&scoped=true&"
import script from "./EditHotel.vue?vue&type=script&lang=js&"
export * from "./EditHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847d90f",
  null
  
)

export default component.exports